import { render } from "./SelectBloodType.vue?vue&type=template&id=b5be29bc"
import script from "./SelectBloodType.vue?vue&type=script&lang=js"
export * from "./SelectBloodType.vue?vue&type=script&lang=js"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__